// extracted by mini-css-extract-plugin
export default {"map":"delivery_map__5PFbJ"};